import {SIGN_TOAST_KEY} from '~/constants/toast';
import {isoDocument} from '~/utils/document';
import {getToastFromStorage, setToastInStorage} from '~/utils/toast';
import {isoWindow} from '~/utils/window';

import {registerShopToastManager} from './ShopToastManager';

registerShopToastManager();

const toastProps = getToastFromStorage(SIGN_TOAST_KEY);
if (toastProps?.text) {
  // Create a new shop-toast-manager element and append it to the document
  const shopToastManager = isoDocument.createElement('shop-toast-manager');
  isoDocument.body.appendChild(shopToastManager);

  // after appending it to the dom, the `loadFeatures` will fetch the feature bundle
  // and define the element. once defined, invoke the `renderToast` method
  customElements
    .whenDefined('shop-toast-manager')
    .then(() => {
      isoWindow.Shopify.SignInWithShop.renderToast(toastProps);
    })
    .catch(() => {});

  setToastInStorage(SIGN_TOAST_KEY, null);
}
